import { Typography } from '@mui/material';
import cn from 'classnames';
import React, { ReactNode } from 'react';

import styles from './Messages.module.css';

interface ErrorMessageProps {
    message?: ReactNode;
    className?: string;
    marginLeft?: number;
    isSubError?: boolean;
}

export const ErrorMessage = ({ message, className, marginLeft, isSubError = false }: ErrorMessageProps) => {
    const fontStyle = isSubError ? styles.subError : styles.mainError;
    return (
        <Typography style={{ marginLeft }} className={cn(styles.errorMessage, fontStyle, className)}>
            {message}
        </Typography>
    );
};
